import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { MatButtonModule } from "@angular/material/button";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatIconModule } from "@angular/material/icon";
import { MatTooltipModule } from "@angular/material/tooltip";
import { FlexModule } from "@vp/shared/directives/flex";
import { TagSearchInputComponent } from "./tag-search-input.component";

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    MatIconModule,
    MatButtonModule,
    MatTooltipModule,
    MatFormFieldModule,
    FlexModule
  ],
  declarations: [TagSearchInputComponent],
  exports: [TagSearchInputComponent]
})
export class TagSearchInputModule {}
